<template>
	<div id="SideMenu">
		<div class='menu__link' style="text-align: right;" @click="table = true">导航栏</div>
		<!-- <el-button type="text" @click="table = true">打开嵌套表格的 Drawer</el-button> -->
		<el-drawer style="font-weight: 1000;" title="留白" :visible.sync="table" direction="rtl" size="15%">
			<!-- <div style="margin: 20px;text-indent:25px">通过虚拟现实技术，让企业更加全面地展示企业的工厂、产品、样板客户案例</div>
			<div style="text-align: center;margin: 20px;">企业的展示更加全面！！！</div>
			<div style="text-align: center;margin: 20px;">产品的特点更加详细！！！</div>
			<div style="text-align: center;margin: 20px;">让客户的印象更加深刻！！</div>
			<div style="text-align: center;margin: 20px;">联系微信：17359875010</div>
 -->


			<div style="font-weight: 1000;width: 90%;" class='button -dark center' @click="toOmission">登录留白空间</div>
			<div style="font-weight: 1000;width: 90%;" class='button -dark center' @click="toMeeting">登录留白会议</div>
			<!-- 			<el-button>1</el-button>
			<el-button>2</el-button>
			<el-button>3</el-button>
			<el-button>4</el-button>
			<el-button>5</el-button>
			<el-button>6</el-button> -->
		</el-drawer>
	</div>
</template>

<script>
	export default {
		name: "SideMenu",
		data() {
			return {
				table: false,
				dialog: false,
				loading: false,
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				timer: null,
			};
		},
		methods: {
			toOmission() {
				window.location.href = "https://omissionvr.com/vue"
			},
			toMeeting() {
				window.location.href = "https://omissionvr.com/screen"
			},
			cancelForm() {
				this.loading = false;
				this.dialog = false;
				clearTimeout(this.timer);
			}
		}
	}
</script>

<style>
</style>
